import { ErrorLike } from '@apollo/client'
import { isErrorLike } from '@apollo/client/errors'
import { useCallback, useState } from 'react'
import { useLingui } from '@lingui/react/macro'

import Button from '@/components/ui/Button'
import { ApolloErrorMessage } from '@/components/ui/ApolloErrorMessage'
import { StepComponentProps } from '../types'

export function ButtonComponent({ step, onSubmit }: StepComponentProps) {
  const { t } = useLingui()

  const [error, setError] = useState<ErrorLike | null>(null)
  const [loading, setLoading] = useState(false)

  const onSubmitProxy = useCallback(() => {
    setLoading(true)
    setError(null)

    onSubmit({})
      .catch(error => {
        if (isErrorLike(error)) setError(error)
      })
      .finally(() => setLoading(false))
  }, [onSubmit, setLoading])

  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-heading1 text-text">{step.title}</h1>
      {step.description && (
        <p className="text-regular text-text">{step.description}</p>
      )}
      <div className="flex flex-col gap-1 p-4">
        <Button onClick={onSubmitProxy} className="w-full" loading={loading}>
          {step.buttonLabel}
        </Button>
        <ApolloErrorMessage
          error={error}
          messageTranslations={{
            credential_error: t`There was an issue with the credentials. Did you complete all steps successfully?`
          }}
        />
      </div>
    </div>
  )
}
